export default "__VITE_ASSET__Cn6S$r$B__"